import React from "react";
import { Nav } from "reactstrap";
import SidebarNav from "./SidebarNav";
import SidebarFooter from "./SidebarFooter";

class Sidebar extends React.Component {
  render() {
    const { accountReducer, updateUserAndCompanyType } = this.props;

    return (
      <div className="adminListSection sidebar" id="adminListSection">
        <Nav className="nav-stacked nav-tabs">
          <SidebarNav
            history={this.props.history}
            typeData={accountReducer.typeData || {}}
            moduleAcl={accountReducer.moduleAcl || []}
            awardCheck={0}
            activeIntegration={accountReducer.activeIntegration || []}
            updateUserAndCompanyType={updateUserAndCompanyType}
            allIntegrations={accountReducer.allIntegrations || []}
          />
        </Nav>

        <SidebarFooter />
      </div>
    );
  }
}

export default Sidebar;
